<template>
  <div class="service-page">
    <!-- 模块一至四：整屏滚动渐入模块 -->
    <div
      v-for="(item, index) in sections"
      :key="item.key"
      class="fullscreen-section reveal-section"
      :class="[item.className, { 'is-visible': visibleMap[index] }]"
    >
      <div class="section-canvas" :style="{ transform: 'scale(' + scale + ')' }">
        <div class="section-inner">
          <!-- 模块一背景图：移入 .section-inner 内部，与半透明框同属一个层叠上下文，使 backdrop-filter 模糊生效 -->
          <img v-if="item.key === 'hero'" src="../assets/images/service/service-1-back.png" class="hero-bg" />

          <!-- ============ 模块一：服务与支持（背景图+大标题） ============ -->
          <div v-if="item.key === 'hero'" class="hero-layout">
            <h2 class="hero-title">{{ $t('service.title') }}</h2>
            <div class="hero-divider"></div>
            <!-- 模块一底部：半透明空框（改 width/height 调大小，改 transform 调位置） -->
            <div class="hero-contact-card">
              <!-- 框内左上角：关注图+文字（改 width 调大小，改 top/left 调位置） -->
              <div class="hero-card-row hero-card-row-guanzhu">
                <img class="hero-card-guanzhu" src="../assets/images/service/service-1-guanzhu.png" alt="关注" />
                <span class="hero-card-tip">{{ $t('service.scanQR') }}{{ $t('service.followUs') }}</span>
              </div>
              <!-- 框内左下角：售后图+文字（改 width 调大小，改 bottom/left 调位置） -->
              <div class="hero-card-row hero-card-row-shouhou">
                <img class="hero-card-shouhou" src="../assets/images/service/service-1-shouhou.png" alt="售后" />
                <span class="hero-card-tip">{{ $t('service.scanQR') }}{{ $t('service.afterSales') }}</span>
              </div>
              <!-- 框内右侧：两个绿色框（邮箱+电话，改 top/right 调整体位置） -->
              <div class="hero-card-links">
                <div class="hero-card-link">
                  <img class="hero-link-icon" src="../assets/images/service/srvice-1-email.png" alt="邮箱" />
                  <div class="hero-link-text">
                    <span class="hero-link-value">{{ $t('service.heroEmail') }}</span>
                    <span class="hero-link-label">{{ $t('service.heroEmailLabel') }}</span>
                  </div>
                </div>
                <div class="hero-card-link">
                  <!-- 英文版切换为 service-1-INTphone.png，中文保持原图 -->
                  <img class="hero-link-icon" :src="$i18n.locale === 'en' ? require('../assets/images/service/service-1-INTphone.png') : require('../assets/images/service/service-1-phone.png')" alt="电话" />
                  <div class="hero-link-text">
                    <span class="hero-link-value">{{ $t('service.heroPhone') }}</span>
                    <span class="hero-link-label">{{ $t('service.heroPhoneLabel') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ============ 模块二：常见问题 ============ -->
          <div v-if="item.key === 'faq'" class="faq-layout">
            <div class="faq-header">
              <h2 class="section-title">{{ $t('service.faqTitle') }}</h2>
              <div class="faq-divider"></div>
            </div>
            <div class="faq-list">
              <div class="faq-item" v-for="(faq, idx) in faqList" :key="idx">
                <div class="faq-question" @click="toggleFaq(idx)">
                  <!-- 问题标题：文案为 i18n 键，展开时变青色 -->
                  <span :class="{ 'is-open': faq.isOpen }">{{ $t(faq.question) }}</span>
                  <!-- 右侧圆形下拉图标：CSS 绘制，展开时中间箭头原地旋转 180 度 -->
                  <span class="faq-icon" :class="{ 'is-open': faq.isOpen }"></span>
                </div>
                <!-- 展开区域：不用 v-show（瞬间显隐无过渡），改用 JS 实测高度做 height 过渡，
                     文字从上到下丝滑滑出；高度样式由 onFaqToggle 行内控制，改高度改 0.4s 见 CSS .faq-answer -->
                <div class="faq-answer" :class="{ 'is-open': faq.isOpen }" :ref="'faqAnswer' + idx">
                  <div class="faq-answer-inner">
                    <p v-if="faq.answer">{{ $t(faq.answer) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ============ 模块三：产品使用教程 ============ -->
          <div v-if="item.key === 'video'" class="video-layout">
            <!-- 模块三标题容器：大标题 + 下方分割线，样式见 CSS 中 .video-header -->
            <div class="video-header">
              <h2 class="section-title">{{ $t('service.tutorialTitle') }}</h2>
              <div class="section-divider"></div>
            </div>
            <!-- 产品使用说明书（PDF）：指向 public/pdf/ 的包装页（自定义标签页标题，内嵌 iframe 显示 PDF） -->
            <a class="pdf-entry" href="pdf/shuoming.html" target="_blank" rel="noopener">
              <span class="pdf-entry-text">{{ $t('service.pdfEntry') }}</span>
              <span class="pdf-entry-icon">
                <span class="arrow"></span>
                <span class="arrow"></span>
                <span class="arrow"></span>
              </span>
            </a>
            <div class="video-list">
              <!-- 佩戴演示卡片：英文版切换为 INTCGM1.mp4，大小位置见 CSS 中 :lang(en) .video-card-wear 调节点 -->
              <div class="video-card video-card-wear">
                <div class="video-player">
                  <video
                    class="video-content"
                    :src="$i18n.locale === 'en' ? require('../assets/video/INTCGM1.mp4') : require('../assets/video/CGM1.mp4')"
                    controls
                    preload="metadata"
                    style="width: 100%; height: 100%; object-fit: contain; background-color: #000;"
                  >
                    {{ $t('service.videoNotSupport') }}
                  </video>
                </div>
                <div class="video-label">{{ $t('service.video1Label') }}</div>
              </div>
              <!-- APP连接演示卡片：英文下隐藏（见 CSS 中 :lang(en) 规则） -->
              <div class="video-card video-card-app">
                <div class="video-player">
                  <video
                    class="video-content"
                    src="../assets/video/CGM2.mp4"
                    controls
                    preload="metadata"
                    style="width: 100%; height: 100%; object-fit: contain; background-color: #000;"
                  >
                    {{ $t('service.videoNotSupport') }}
                  </video>
                </div>
                <div class="video-label">{{ $t('service.video2Label') }}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'

export default {
  name: 'ServicePage',
  components: {
    Footer
  },
  data() {
    return {
      scale: 1,
      baseZoom: 1,
      sections: [
        { key: 'hero', className: 'module-hero' },       // 模块一：服务与支持
        { key: 'faq', className: 'module-faq' },          // 模块二：常见问题
        { key: 'video', className: 'module-video' }       // 模块三：产品使用教程
      ],
      visibleMap: {},
      observer: null,
      // FAQ 列表：question/answer 存 i18n 键（模板中 $t 渲染，随语言切换），文案见 zh.js/en.js 的 service.faqQ1~faqA8
      faqList: [
        { question: 'service.faqQ1', answer: 'service.faqA1', isOpen: false },
        { question: 'service.faqQ2', answer: 'service.faqA2', isOpen: false },
        { question: 'service.faqQ3', answer: 'service.faqA3', isOpen: false },
        { question: 'service.faqQ4', answer: 'service.faqA4', isOpen: false },
        { question: 'service.faqQ5', answer: 'service.faqA5', isOpen: false },
        { question: 'service.faqQ6', answer: 'service.faqA6', isOpen: false },
        { question: 'service.faqQ7', answer: 'service.faqA7', isOpen: false },
        { question: 'service.faqQ8', answer: 'service.faqA8', isOpen: false }
      ]
    }
  },
  mounted() {
    // 滚动吸附由 App.vue 按断点统一管理；语言切换后答案文字高度会变，重算已展开项的行内高度避免截断，
    // transition 置空避免重算时触发滑动动画（页面级淡入已由 .section-inner 承担）
    this.$watch('$i18n.locale', () => {
      this.faqList.forEach((faq, index) => {
        if (!faq.isOpen) return
        const ref = this.$refs['faqAnswer' + index]
        const el = ref && ref[0]
        if (!el) return
        el.style.transition = 'none'
        el.style.height = el.scrollHeight + 'px'
        void el.offsetHeight
        el.style.transition = ''
      })
    })
    this.baseZoom = window.devicePixelRatio || 1
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
    this.initObserver()
    this.scrollToQueryModule()
    // 无 ?to= 参数时强制滚到模块一；iOS Safari 的 scrollBehavior {x:0,y:0} 不可靠，
    // 且 scroll-snap 可能把页面吸附到非顶部的模块，需先禁用 snap 再滚动
    if (!this.$route.query.to) {
      const sections = this.$el.querySelectorAll('.fullscreen-section')
      // 临时禁用所有模块与页脚的 scroll-snap，防止 mandatory 吸附把页面拉到页脚（Footer 的 align: end 始终有效）
      const footer = this.$el.querySelector('.footer')
      sections.forEach(s => { s.style.scrollSnapAlign = 'none' })
      if (footer) footer.style.scrollSnapAlign = 'none'
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo(0, 0)
          // 等滚动稳定后恢复所有元素的 snap
          setTimeout(() => {
            sections.forEach(s => { s.style.scrollSnapAlign = 'start' })
            if (footer) footer.style.scrollSnapAlign = ''
          }, 200)
        }, 50)
      })
    }
    // 初始全部收起：行内高度置 0，展开时从 0 向实测高度过渡（行内优先级高于 CSS 默认）
    this.$nextTick(() => {
      this.faqList.forEach((faq, index) => {
        if (faq.isOpen) return
        const ref = this.$refs['faqAnswer' + index]
        const el = ref && ref[0]
        if (el) el.style.height = '0px'
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScale)
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
  methods: {
    updateScale() {
      const fit = Math.max(window.innerWidth / 1920, window.innerHeight / 1080)
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.scale = fit * zoom
    },
    initObserver() {
      if (!('IntersectionObserver' in window)) {
        this.sections.forEach((item, index) => {
          this.$set(this.visibleMap, index, true)
        })
        return
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index)
          this.$set(this.visibleMap, index, entry.isIntersecting)
        })
      }, {
        threshold: 0.15
      })
      this.$nextTick(() => {
        const els = this.$el.querySelectorAll('.reveal-section')
        els.forEach((el, index) => {
          el.dataset.index = index
          this.observer.observe(el)
        })
      })
    },
    toggleFaq(index) {
      const isOpen = !this.faqList[index].isOpen
      this.faqList[index].isOpen = isOpen
      this.onFaqToggle(index, isOpen)
    },
    // FAQ 展开/收起：行内全程接管 height（展开=实测高度，收起=0），不依赖 transitionend，
    // 避免快速连点时残留监听器把高度清成 auto 导致留白；内容高度变化（如切语言）由下方监听器重算
    onFaqToggle(index, isOpen) {
      this.$nextTick(() => {
        const ref = this.$refs['faqAnswer' + index]
        const el = ref && ref[0]
        if (!el) return
        if (isOpen) {
          el.style.height = el.scrollHeight + 'px'
        } else {
          // 行内当前必是展开高度（像素值），直接向 0 过渡即可平滑收起；
          // 强制回流，确保过渡从当前高度出发而非瞬间跳变
          void el.offsetHeight
          el.style.height = '0px'
        }
      })
    },
    // 页脚带 ?to= 参数进入时滚到对应模块（hero 模块一 / faq 模块二 / video 模块三）；
    // 延迟一拍等页面渲染完成后再滚动，避免 scroll-snap 与渐入动效干扰
    scrollToQueryModule() {
      const anchor = this.$route.query.to
      if (!anchor) return
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('.module-' + anchor)
          if (el) {
            el.scrollIntoView({ behavior: 'auto' })
          }
        }, 100)
      })
    }
  }
}
</script>

<style scoped>
/* ============================================================
 * 页面级公共样式（整屏容器、画布、动效、通用标题区）
 * ============================================================ */

.service-page {
  padding-top: 0;
}

/* 全屏高度纵向模块，配合页面级 scroll-snap 实现整屏吸附切页 */
.fullscreen-section {
  height: 100vh;
  /* 手机端用 JS 实时写入的可见高度（App.vue），避免 100vh 高于可见区导致底部裁切；桌面不受影响 */
  height: var(--app-height, 100vh);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.reveal-section {
  position: relative;
  background: #FFFFFF;
}

/* 设计稿画布：四个模块共用的固定尺寸容器，整体等比缩放 */
.section-canvas {
  position: relative;
  width: 1920px;
  height: 1080px;
  flex-shrink: 0;
  transform-origin: center center;
}

.reveal-section .section-inner {
  position: relative;
  width: 100%;
  height: 100%;
  opacity: 0;
  transform: translateY(48px);
  /* 隐藏态不设过渡：切页离开瞬间重置，切回时子元素独立动效完整重播 */
  will-change: opacity, transform;
}

.reveal-section.is-visible .section-inner {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* ============================================================
 * 模块一：服务与支持（背景图+大标题）
 * ============================================================ */

.module-hero {
  background: #FFFFFF;
}

/* 模块一背景图：移入 .section-inner 内部，与半透明框同属一个层叠上下文，使 backdrop-filter 能模糊到背景图；
   absolute 铺满父容器，z-index: 0 确保在内容下方 */
.module-hero .hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  z-index: 0;
}

.module-hero .hero-layout {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  z-index: 10;
}

.module-hero .hero-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 72px;
  color: #FFFFFF;
  line-height: 1.2;
  text-align: center;
  transform: translate(0, -50px)
}

.module-hero .hero-divider {
  width: 400px;
  height: 1px;
  background-color: #FFFFFF;
  transform: translate(0, -30px);
}

/* 模块一：半透明空框（改 width/height 调大小，改 transform 调位置） */
.module-hero .hero-contact-card {
  position: relative;
  width: 1100px;
  height: 400px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 24px;
  backdrop-filter: blur(6px);
  box-sizing: border-box;
  transform: translate(0, 150px);
  /* 投影：X:0 Y:4px Blur:4px Spread:0 #000 10% */
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
}

/* 渐变边框：3px 线性渐变（白色→透明→白色），通过伪元素实现 */
.module-hero .hero-contact-card::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 24px;
  padding: 3px;                  /* 边框宽度 */
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 19%,
    rgba(255, 255, 255, 1) 34%,
    rgba(255, 255, 255, 0) 57%,
    rgba(255, 255, 255, 1) 100%
  );
  -webkit-mask: 
    linear-gradient(#fff 0 0) content-box, 
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

/* 模块一：框内二维码行容器（图片+右侧文字，改 top/bottom/left 调整行位置） */
.module-hero .hero-card-row {
  position: absolute;
  left: 50px;
  display: flex;
  align-items: center;
  gap: 30px;
}

.module-hero .hero-card-row-guanzhu {
  top: 30px;
}

.module-hero .hero-card-row-shouhou {
  bottom: 30px;
}

/* 模块一：框内关注图（改 width 调大小） */
.module-hero .hero-card-guanzhu {
  width: 160px;
  height: auto;
  object-fit: contain;
  border-radius: 18px;
}

/* 模块一：框内售后图（改 width 调大小） */
.module-hero .hero-card-shouhou {
  width: 160px;
  height: auto;
  object-fit: contain;
  border-radius: 18px;
}

/* 模块一：二维码右侧提示文字（改 font-size 调大小，改 gap 调图文间距） */
.module-hero .hero-card-tip {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 28px;
  color: #252525;
  white-space: nowrap;
}

/* 仅英文生效：二维码右侧提示文字（Scan QR Code...）单独调字号，只改 font-size */
:lang(en) .module-hero .hero-card-tip {
  font-size: 22px;
}

/* 模块一：框内右侧两个绿色框容器（改 top/right 调位置，改 gap 调两框间距） */
.module-hero .hero-card-links {
  position: absolute;
  top: 50%;
  right: 80px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 60px;
}

/* 模块一：单个绿色框（改 width/padding 调大小，改 font-size 调文字大小，改 gap 调图标与文字间距） */
.module-hero .hero-card-link {
  width: 380px;
  padding: 20px 20px;
  background: #00ADBB;
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 26px;
  color: #FFFFFF;
  text-align: center;
  line-height: 36px;
}

/* 仅英文生效：透明框内隐藏左侧两行二维码（关注/售后），只保留两个绿色框 */
:lang(en) .module-hero .hero-card-row {
  display: none;
}

/* 仅英文生效：两个绿色框在透明框内水平居中（改 gap 调两框间距，改 top 调上下位置） */
:lang(en) .module-hero .hero-card-links {
  left: 50%;
  right: auto;
  transform: translate(-50%, -50%);
  align-items: center;
}

/* 仅英文生效：第一个绿色框（邮箱）独立大小调节点，改 width/padding 只影响这一块 */
:lang(en) .module-hero .hero-card-links .hero-card-link:nth-child(1) {
  width: 450px;
  padding: 20px 20px;
}

/* 仅英文生效：第二个绿色框（电话）独立大小调节点，改 width/padding 只影响这一块 */
:lang(en) .module-hero .hero-card-links .hero-card-link:nth-child(2) {
  width: 450px;
  padding: 20px 20px;
}

/* 模块一：绿色框内左侧图标（改 width/height 调大小） */
.module-hero .hero-link-icon {
  width: 76px;
  height: 76px;
  object-fit: contain;
  flex-shrink: 0;
}

/* 模块一：绿色框内两行文字（上行数值+下行说明，左对齐） */
/* 固定宽度使两个绿框内容总宽一致，保证左侧图标对齐（改 width 调文字区宽度） */
.module-hero .hero-link-text {
  width: 270px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.module-hero .hero-link-value {
  font-size: 24px;
  line-height: 36px;
}

.module-hero .hero-link-label {
  font-size: 20px;
  line-height: 28px;
  color: rgba(255, 255, 255, 0.85);
}

/* ------------------------------------------------------------
 * 模块一动效独立拆分：大标题与半透明框各自为一个动效，互不影响，
 * 透明度与父层 .section-inner 相乘生效；隐藏态不设过渡，切页离开瞬间重置，切回来完整重播，
 * 隐藏态保留各自布局 translate 基准，动画位移叠加在其后，不改变最终位置。
 * 每组调节点：改 0.8s 调动画时长，改末尾延迟调晚多久出现，改 translateY(24px) 调上移幅度
 * ------------------------------------------------------------ */

/* 第1组：大标题（.hero-title），延迟 0s */
.reveal-section .hero-title {
  opacity: 0;
  transform: translate(0, -50px) translateY(24px);
}

.reveal-section.is-visible .hero-title {
  opacity: 1;
  transform: translate(0, -50px) translateY(0);
  transition: opacity 0.8s ease 0s,
    transform 0.8s ease 0s;
}

/* 第2组：半透明框连带框内全部内容一起入场（.hero-contact-card），延迟 0.2s 错开 */
.reveal-section .hero-contact-card {
  opacity: 0;
  transform: translate(0, 150px) translateY(50px);
}

.reveal-section.is-visible .hero-contact-card {
  opacity: 1;
  transform: translate(0, 150px) translateY(0);
  transition: opacity 0.8s ease 0.4s,
    transform 0.8s ease 0.2s;
}

/* ============================================================
 * 模块二：常见问题
 * ============================================================ */

.module-faq {
  background: #FFFFFF;
}

.module-faq .faq-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 160px;
  padding-bottom: 60px;
}

/* 标题区：与问题列表同宽并左对齐，使大标题、下划线与问题标题左侧对齐 */
/* 左右 padding 10px 与问题条目的内边距一致，保证文字左边缘完全对齐 */
.module-faq .faq-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 1100px;
  box-sizing: border-box;
  padding: 0 10px;
}

/* 模块二大标题（常见问题）：黑色粗体，改 font-size 调大标题大小，text-align 控制对齐方向 */
.module-faq .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 460;
  font-size: 46px;
  color: #000000;
  line-height: 1.2;
  margin: 10px 0 16px 0;
  text-align: left;
}

/* 模块二标题下方短横线（改 width 调线宽） */
.module-faq .faq-divider {
  width: 220px;
  height: 2px;
  background-color: #000000;
  margin-bottom: 0px;
}

/* 问题列表：条目间以细灰线分隔（改 width 调列表宽度） */
/* 列表占满标题下方剩余屏高，内容超出时屏内滚动，滚到底再继续才翻到下一页 */
.module-faq .faq-list {
  display: flex;
  flex-direction: column;
  width: 1100px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

/* 列表细滚动条，避免默认粗滚动条影响视觉 */
.module-faq .faq-list::-webkit-scrollbar {
  width: 6px;
}

.module-faq .faq-list::-webkit-scrollbar-thumb {
  background: #CCCCCC;
  border-radius: 3px;
}

.module-faq .faq-list::-webkit-scrollbar-track {
  background: transparent;
}

.module-faq .faq-item {
  border-bottom: 1px solid #DDDDDD;
}

/* 最后一项不显示分隔线 */
.module-faq .faq-item:last-child {
  border-bottom: none;
}

/* 最后一项仅在展开时下方留白（留白在内层，随高度动画一起展开/收起），改 padding-bottom 调留白大小 */
.module-faq .faq-item:last-child .faq-answer .faq-answer-inner {
  padding-bottom: 80px;
}

.module-faq .faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 26px 10px 20px;
  cursor: pointer;
}

/* 问题标题：改 font-size/line-height 调每条问题文字的大小，展开时变青色 */
.module-faq .faq-question span {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 460;
  font-size: 26px;
  color: #000000;
  line-height: 20px;
  text-align: left;
  transition: color 0.1s ease;
}

/* 展开时问题标题变青色 */
.module-faq .faq-question span.is-open {
  color: #00ADBB;
}

/* 右侧圆形下拉图标：灰色圆形边框保持不动，中间箭头原地平面旋转 180 度 */
.module-faq .faq-icon {
  width: 42px;
  height: 42px;
  border: 2px solid #252525;
  border-radius: 50%;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 箭头本体：旋转动效加在箭头上（改 0.4s 调旋转快慢，与展开/收起节奏同步） */
.module-faq .faq-icon::after {
  content: '';
  width: 10px;
  height: 10px;
  border-right: 2px solid #252525;
  border-bottom: 2px solid #252525;
  transform: rotate(45deg) translate(-2px, -2px);
  transition: transform 0.4s ease;
}

/* 展开态：箭头原地旋转 180 度（45+180=225，V 转成 ^），收起时转回 */
.module-faq .faq-icon.is-open::after {
  transform: rotate(225deg) translate(-2px, -2px);
}

/* 展开区域：高度由 JS 行内控制（0→实测高度），改 0.4s 调展开/收起速度，改 ease 调节奏曲线 */
.module-faq .faq-answer {
  overflow: hidden;
  text-align: left;
  background: transparent;
  transition: height 0.4s ease;
}

/* 展开正文：改 font-size/line-height 调展开后答案文字的大小；
   滚动位移：展开时整块文字从标题处向下滚出（-100%→0），收起时向上滚回标题处（0→-100%），
   与容器高度过渡同步 0.4s；改 translateY(-100%) 幅度可调滚动距离（如 -50% 只滚半块） */
.module-faq .faq-answer p {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 24px;
  color: #B3B3B3;
  line-height: 32px;
  white-space: pre-line;
  margin: 0;
  padding: 0 10px 26px;
  transform: translateY(0px);
  transition: transform 0.4s ease;
}

/* 收起态：整块文字滚回标题处（位移在裁切区上方不可见；过渡由上方基础规则提供） */
.module-faq .faq-answer:not(.is-open) p {
  transform: translateY(-100%);
}

/* ============================================================
 * 模块三：产品使用教程
 * ============================================================ */

.module-video {
  background: #F5F5F5;
}

.module-video .video-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 400px;
}

/* 模块三标题容器：标题区整体布局（改 align-items 调对齐方式，高度由内容撑开） */
/* 标题+分割线一起移动：改 transform 两个值（向右、向下），不影响下方视频 */
.module-video .video-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translate(0, -180px);
}

/* 模块三大标题（产品使用教程）：独立调节，改 font-size/line-height 调标题大小 */
/* 调位置：改 transform 两个值（向右、向下），只移标题本身，不影响分割线和视频 */
.module-video .section-title {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 46px;
  color: #000000;
  line-height: 1.2;
  text-align: center;
  margin: 0 0 20px 0;
  transform: translate(0, 0);
}

/* 模块三标题下方分割线：改 width 调线宽、margin 调与下方内容的间距 */
.module-video .section-divider {
  width: 400px;
  height: 1px;
  background-color: #000000;
  margin: 0 auto 24px;
}

/* 产品使用说明书（PDF）入口：白色圆角横幅，改 width/padding 调大小，改 margin-top 调与上方间距 */
.module-video .pdf-entry {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1430px;
  box-sizing: border-box;
  padding: 26px 60px;
  margin-top: -140px;
  background: #FFFFFF;
  border-radius: 20px;
  box-shadow: none;     /* 0 4px 16px rgba(0, 0, 0, 0.06) */
  text-decoration: none;
  cursor: pointer;
}

/* PDF 入口左侧文字：改 font-size 调文字大小 */
.module-video .pdf-entry-text {
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 30px;
  color: #252525;
  line-height: 1.2;
}

/* PDF 入口右侧青色三箭头：从左到右渐变（浅青→中青→深青） */
.module-video .pdf-entry-icon {
  position: relative;
  width: 54px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 0;
}

.module-video .pdf-entry-icon .arrow {
  width: 20px;
  height: 20px;
  border-top: 4px solid;
  border-right: 4px solid;
  transform: rotate(45deg);
  flex-shrink: 0;
}

/* 三个箭头分别用不同青色，形成从左到右由浅到深的渐变效果 */
.module-video .pdf-entry-icon .arrow:nth-child(1) {
  border-color: #80D6DC; /* 浅青 - 最亮 */
}

.module-video .pdf-entry-icon .arrow:nth-child(2) {
  border-color: #00ADBB; /* 中青 - 标准色 */
}

.module-video .pdf-entry-icon .arrow:nth-child(3) {
  border-color: #008A96; /* 深青 - 最暗 */
}

.module-video .video-list {
  display: flex;
  justify-content: center;
  gap: 90px;
  margin-top: 80px;
}

.module-video .video-card {
  width: 668px;
  background: #FFFFFF;
  border-radius: 16px;
  overflow: hidden;
}

.module-video .video-player {
  width: 100%;
  height: 320px;
  background: #C0C0C0;
  position: relative;
}

.module-video .video-label {
  padding: 20px;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: #000000;
  line-height: 32px;
  text-align: center;
}

/* 仅英文生效：隐藏产品使用说明书（PDF）入口，删除此规则即可恢复显示 */
:lang(en) .module-video .pdf-entry {
  display: none;
}

/* 仅英文生效：隐藏 APP 连接演示卡片，删除此规则即可恢复显示 */
:lang(en) .module-video .video-card-app {
  display: none;
}

/* 仅英文生效：佩戴演示卡片（INTCGM1.mp4）单独控制大小和位置 */
/* 改 width 调卡片宽度，改下方 .video-player 的 height 调视频区高度 */
/* 改 transform 两个值（向右、向下）调位置，不影响其他元素占位 */
:lang(en) .module-video .video-card-wear {
  width: 800px;
  transform: translate(0, -150px);
}

:lang(en) .module-video .video-card-wear .video-player {
  height: 360px;
}

/* ============================================================
 * 页脚与动效降级
 * ============================================================ */

.service-page >>> .footer {
  scroll-snap-align: end;
}






/* ============================================================
 * 移动端适配（<= 1024px）：禁用画布缩放并逐模块接管布局，
 * !important 覆盖行内 transform（JS 缩放值）；仅手机端生效，不影响桌面端，
 * 布局用文档流（flex column + 取消绝对定位），间距用 vh，字号用 vw（375px 屏宽基准），
 * 图片/图标尺寸用 vh（700px 屏高基准）；手机端英文单独微调用 :lang(en) 写在媒体查询内，
 * 各数值按注释提示自行微调
 * ============================================================ */
@media (max-width: 1024px) {
  .section-canvas {
    transform: none !important;
    width: 100%;
    height: 100%;
  }

  /* 全部流式项禁止被 flex 压缩：内容总高超出整屏时，
     细元素（1px 分割线等）会被默认收缩直接压成 0 而消失，
     超出部分应落到底部裁切区而不是压缩内容 */
  .service-page .section-inner * {
    flex-shrink: 0;
  }

  /* ---------- 模块一：服务与支持 ---------- */

  /* 内容容器：垂直居中改顶对齐 + padding-top 预留固定导航栏（手机端高 60px） */
  .module-hero .hero-layout {
    justify-content: flex-start;
    padding-top: 16vh;
  }

  /* 大标题：字号改 vw，去掉桌面上移偏移，间距改 vh（改 font-size/margin 微调） */
  .module-hero .hero-title {
    font-size: 8vw;
    transform: none;
    margin: 0 0 2vh 0;
  }

  :lang(en) .module-hero .hero-title {  /* 大标题（英文单独调节字号） */
    font-size: 6.93vw;
  }

  /* 标题下分割线：去掉桌面上移偏移，下方间距改 vh（改 width 调线宽） */
  .module-hero .hero-divider {
    width: 200px;
    transform: none;
    margin: 0 0 4vh 0;
  }

  /* 半透明卡：固定尺寸改通栏文档流纵向堆叠（改 width/padding/gap 调大小与内部间距） */
  .module-hero .hero-contact-card {
    width: 88%;
    height: auto;
    transform: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3vh;
    padding: 3vh 5%;
  }

  /* 二维码行：绝对定位改文档流（改 gap 调图文间距） */
  .module-hero .hero-card-row {
    position: static;
    left: auto;
    top: auto;
    bottom: auto;
    gap: 4vw;
  }

  /* 二维码图：尺寸改 vh（改 width 调大小） */
  .module-hero .hero-card-guanzhu,
  .module-hero .hero-card-shouhou {
    width: 12vh;
    border-radius: 2vh;
  }

  .module-hero .hero-card-tip {
    font-size: 3.47vw;
    white-space: normal;
  }

  :lang(en) .module-hero .hero-card-tip {  /* 提示文字（英文单独调节字号） */
    font-size: 3.2vw;
  }

  /* 两个绿色框：右侧绝对定位改文档流通栏堆叠（改 gap 调两框间距） */
  .module-hero .hero-card-links {
    position: static;
    left: auto;
    right: auto;
    top: auto;
    transform: none;
    width: 100%;
    gap: 2vh;
  }

  /* 英文版桌面居中规则（:lang(en) 优先级更高）手机端重置：去掉 left/transform 居中偏移 */
  :lang(en) .module-hero .hero-card-links {
    left: auto;
    transform: none;
  }

  .module-hero .hero-card-link {
    width: 100%;
    padding: 1.5vh 3%;
    gap: 3vw;
    font-size: 3.73vw;
    line-height: 1.4;
  }

  /* 英文版两绿框桌面单独加宽（带 :nth-child 优先级更高），手机上逐一重置为通栏堆叠 */
  :lang(en) .module-hero .hero-card-links .hero-card-link:nth-child(1),
  :lang(en) .module-hero .hero-card-links .hero-card-link:nth-child(2) {
    width: 100%;
    padding: 1.5vh 3%;
  }

  /* 绿框内图标：尺寸改 vh（改 width/height 调大小） */
  .module-hero .hero-link-icon {
    width: 7vh;
    height: 7vh;
  }

  .module-hero .hero-link-text {
    /* 例外：横向 flex（图标+文字）中的文字区，恢复收缩防止长邮箱/号码溢出 */
    flex-shrink: 1;
    min-width: 0;
    width: auto;
    flex: 1;
  }

  .module-hero .hero-link-value {
    font-size: 3.47vw;
    line-height: 1.4;
  }

  .module-hero .hero-link-label {
    font-size: 2.93vw;
    line-height: 1.4;
  }

  /* 动效位移配对覆盖：桌面动效规则带布局 translate 偏移，
     手机端隐藏/可见两态都要覆盖，否则入场时位置跳变 */
  .reveal-section .hero-title {
    transform: translateY(24px);
  }

  .reveal-section.is-visible .hero-title {
    transform: translateY(0);
  }

  .reveal-section .hero-contact-card {
    transform: translateY(50px);
  }

  .reveal-section.is-visible .hero-contact-card {
    transform: translateY(0);
  }

  /* ---------- 模块二：常见问题 ---------- */

  /* 整体布局：顶对齐 + padding-top 预留固定导航栏 */
  .module-faq .faq-layout {
    padding-top: 76px;
    padding-bottom: 2vh;
  }

  /* 标题区与问题列表：固定宽改通栏（两侧 6% 留白），两者同步保持左边缘对齐 */
  .module-faq .faq-header {
    width: 100%;
    box-sizing: border-box;
    padding: 0 6%;
  }

  .module-faq .section-title {
    font-size: 5.87vw;
    line-height: 1.3;
    margin: 0 0 1vh 0;
  }

  :lang(en) .module-faq .section-title {  /* 大标题（英文单独调节字号） */
    font-size: 5.33vw;
  }

  .module-faq .faq-divider {
    width: 200px;
    margin-bottom: 2vh;
  }

  /* 问题列表：占满标题下方剩余屏高内部滚动；
     例外：恢复 flex 收缩（覆盖顶部全局不压缩规则），否则列表无法压缩直接溢出 */
  .module-faq .faq-list {
    flex-shrink: 1;
    width: 100%;
    box-sizing: border-box;
    padding: 0 6%;
  }

  .module-faq .faq-question {
    padding: 2vh 0;
    gap: 3vw;
  }

  .module-faq .faq-question span {
    /* 例外：横向 flex（文字+图标）需恢复收缩并允许换行 */
    flex-shrink: 1;
    min-width: 0;
    font-size: 4vw;
    line-height: 1.4;
    white-space: normal;
  }

  :lang(en) .module-faq .faq-question span {  /* 问题标题（英文单独调节字号） */
    font-size: 3.73vw;
  }

  /* 圆形图标与箭头：尺寸改 vh（改 width/height 调大小） */
  .module-faq .faq-icon {
    width: 6vh;
    height: 6vh;
  }

  .module-faq .faq-icon::after {
    width: 1.5vh;
    height: 1.5vh;
  }

  .module-faq .faq-answer p {
    font-size: 3.47vw;
    line-height: 1.6;
    padding: 0 0 3vh;
  }

  :lang(en) .module-faq .faq-answer p {     /* 答案正文（英文单独调节字号） */
    font-size: 3.2vw;
  }

  /* 最后一项底部留白手机端收紧（留白在内层，随高度动画一起展开/收起） */
  .module-faq .faq-item:last-child .faq-answer .faq-answer-inner {
    padding-bottom: 8vh;
  }

  /* ---------- 模块三：产品使用教程 ---------- */

  /* 整体布局：去掉桌面超大 padding，顶对齐 + padding-top 预留固定导航栏 */
  .module-video .video-layout {
    padding-top: 12vh;
  }

  :lang(en) .module-video .video-layout {  /* 英文单独调节 padding-top */
    padding-top: 16vh;
  }

  /* 标题区：去掉桌面上移偏移，位置由容器顶对齐接管 */
  .module-video .video-header {
    transform: none;
  }

  .module-video .section-title {
    font-size: 5.87vw;
    margin: 0 0 2vh 0;
  }

  :lang(en) .module-video .section-title {  /* 大标题（英文单独调节字号） */
    font-size: 5.33vw;
  }

  .module-video .section-divider {
    width: 200px;
    margin: 0 auto 3vh;
  }

  /* PDF 说明书入口：固定宽改 88% 通栏横幅，去掉桌面负 margin 上移（改 width/padding 调大小） */
  .module-video .pdf-entry {
    width: 88%;
    padding: 2vh 5%;
    margin-top: 0;
    border-radius: 12px;
  }

  .module-video .pdf-entry-text {
    font-size: 4vw;
  }

  /* 右侧三箭头：尺寸改 vh（改 width/height 调大小） */
  .module-video .pdf-entry-icon {
    width: 7.5vh;
    height: 5vh;
    gap: 0;
  }

  .module-video .pdf-entry-icon .arrow {
    width: 2.3vh;
    height: 2.3vh;
  }

  /* 两个视频卡：横排改竖向堆叠（改 gap 调卡片间距，改 margin-top 调与上方间距） */
  .module-video .video-list {
    flex-direction: column;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding: 0 6%;
    gap: 3vh;
    margin-top: 3vh;
  }

  .module-video .video-card {
    width: 100%;
  }

  /* 视频区高度改 vh（改 height 调高矮） */
  .module-video .video-player {
    height: 24vh;
  }

  .module-video .video-label {
    padding: 2vh;
    font-size: 3.73vw;
    line-height: 1.4;
  }

  /* 英文版佩戴卡片桌面单独加宽并上移，手机端重置（英文 APP 卡片与 PDF 入口保持桌面规则隐藏） */
  :lang(en) .module-video .video-card-wear {
    width: 100%;
    transform: none;
  }

  :lang(en) .module-video .video-card-wear .video-player {
    height: 45vh;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal-section .section-inner {
    transition: none;
    opacity: 1;
    transform: none;
  }
}
</style>
